import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { StorageGetItem, StorageSetItem } from "../admin/components/StorageComp";

const WebsiteContext = createContext(null);

export const WebsiteProvider = ({ children }) => {
    const [currentDomain, setCurrentDomain] = useState('');
    const [websiteData, setWebsiteData] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchWebsite = async (domain) => {
        try {
            const response = await axios.get(
                process.env.REACT_APP_API_URL + "v1/website/website-by-domain",
                {
                    params: { domain },
                }
            );

            const data = response.data.data || null;

            setWebsiteData(data);

            if (data) {
                StorageSetItem("EFL-Domain-Data", data);
            }

            return data;
        } catch (error) {
            return null;
        }
    };

    useEffect(() => {
        const loadWebsite = async () => {
            try {
                let domain = window.location.hostname;

                if (window.location.port) {
                    domain += ":" + window.location.port;
                }

                setCurrentDomain(domain);

                // main domain -> no website config needed
                if (domain === process.env.REACT_APP_BASE_DOMAIN) {
                    setLoading(false);
                    return;
                }

                let cache = StorageGetItem("EFL-Domain-Data");

                if (cache) {
                    if (cache?.domain === domain) {
                        setWebsiteData(cache);
                        setLoading(false);
                        return;
                    }
                }

                await fetchWebsite(domain);
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        };

        loadWebsite();
    }, []);

    return (
        <WebsiteContext.Provider
            value={{
                websiteData,
                setWebsiteData,
                currentDomain,
                setCurrentDomain,
                loading,
                refreshWebsite: fetchWebsite,
            }}
        >
            {children}
        </WebsiteContext.Provider>
    );
};

export const useWebsite = () => {
    return useContext(WebsiteContext);
};